const moment = require('moment-timezone');
import { convertArrayToCSV } from 'convert-array-to-csv'
import { setRequestStatus, setResponseStatus } from './set-status';

/*
    used to export and download csv file into a javascript array
    first parameter is an javascript array: required field
    second parameter is a file name: required field
*/
export async function exportCSV(selectedArray, filename, excludeColumns = [], dateFields = [], dateFormat = 'MM/DD/YYYY HH:mm') {
    if(!Array.isArray(selectedArray)) {
        return;
    }
    if(filename.length == 0) {
        return;
    }
    if(Array.isArray(selectedArray) && selectedArray.length == 0) {
        return;
    }
    if(!Array.isArray(dateFields)) {
        return;
    }
    var keys = await Object.keys(selectedArray[0]).filter(key => {
        if(excludeColumns.length) {
            if(excludeColumns.indexOf(key) == -1) {
                return key;
            }
        } else {
            return key;
        }
    });
    keys = keys.filter(key => key !== 'memberRel')
    if (filename == 'engagement') {
        keys = ["date", "community", "circleId", "requestId", "member", "email1", "studentId", "propertyId", "member_role", "capacity", "propensity", "engagement", "school", "department", "year", "type", "typeDetail", "title", "text", "points", "time", "tags", "customer_custom1", "customer_custom2"];
    }
    if (filename == 'no-follow-up') {
        const memberEmailIndex = keys.indexOf('memberEmail');
        const memberRoleIndex = keys.indexOf('memberRole');
        if (memberEmailIndex !== -1 && memberRoleIndex !== -1) {
            keys.splice(memberRoleIndex, 1);
            keys.splice(memberEmailIndex + 1, 0, 'memberRole');
        }
    }
    if (filename == 'interaction') {
        for (var i = 0; i < excludeColumns[1]; i++) {
            let j = i+1;
            keys.push('response'+j);
            keys.push('response_date'+j);
            keys.push('advisor_email'+j);
            keys.push('property_id'+j);
            keys.push('feedback_score'+j);
            keys.push('feedback'+j);
            keys.push('open'+j);
            keys.push('click'+j);
            keys.push('thankYou'+j);
            keys.push('followUp'+j);
        }
    }

    if (filename == 'referrals') {
        if (!keys.includes('title')) {
            keys.push('title');
        }
        if (!keys.includes('circle')) {
            keys.push('circle');
        }
        if (!keys.includes('text')) {
            keys.push('text');
        }
    }

    if (filename == 'requests') {
    const currentIndex = keys.indexOf('requestId');
    if (currentIndex !== -1 && currentIndex !== 2) {
        keys = array_move(keys, currentIndex, 3);
    }
}
    var values = selectedArray.map(value => {

        if (filename == 'engagement') {
            // memberRole is a populated Member object for Analytics rows and paginated UI calls.
            const rel = value.memberRel && typeof value.memberRel === 'object' && !Array.isArray(value.memberRel) ? value.memberRel : null;
            value['member_role'] = (rel && rel.member_role) ? rel.member_role : (value.member_role || '');
            value['capacity']    = (rel && rel.capacity)    ? rel.capacity    : (value.Capacity    || '');
            value['propensity']  = (rel && rel.propensity)  ? rel.propensity  : (value.Propensity  || '');
            value['engagement']  = (rel && rel.engagement)  ? rel.engagement  : (value.Engagement  || '');

            if (rel) {
                if (!value['school'] && rel.school1) value['school'] = rel.school1;
                if (!value['department'] && rel.department1) value['department'] = rel.department1;
                if (!value['year'] && rel.year1) value['year'] = rel.year1;
                if (!value['studentId'] && rel.studentId) value['studentId'] = rel.studentId;
                if (!value['propertyId'] && rel.propertyId) value['propertyId'] = rel.propertyId; if (!value['customer_custom1'] && rel.customer_custom1) value['customer_custom1'] = rel.customer_custom1;
                if (!value['customer_custom2'] && rel.customer_custom2) value['customer_custom2'] = rel.customer_custom2;
            }
        }

        if (filename == 'interaction') {
            for (var i = 0; i < value.responses.length; i++) {
                let j = i+1;
                let response_key = 'response'+j;
                let response_date_key = 'response_date'+j;
                let advisor_email_key = 'advisor_email'+j;
                let property_id_key = 'property_id'+j;
                let feedback_score_key = 'feedback_score'+j;
                let feedback_key = 'feedback'+j;
                let open_key = 'open'+j;
                let click_key = 'click'+j;
                let thankYou_key = 'thankYou'+j;
                let followUp_key = 'followUp'+j;
                value[response_key] = value.responses[i].response1;
                value[response_date_key] = value.responses[i].response_date;
                value[advisor_email_key] = value.responses[i].advisor_email;
                value[property_id_key] = value.responses[i].property_id;
                value[feedback_score_key] = value.responses[i].feedback_score;
                value[feedback_key] = value.responses[i].feedback;
                value[open_key] = value.responses[i].open;
                value[click_key] = value.responses[i].click;
                value[thankYou_key] = value.responses[i].thankYou;
                value[followUp_key] = value.responses[i].followUp;
            }
        }
        var data = keys.map((key, index) => {
            if(key == 'status') {
                if (filename === 'responses') {
                    if (value.isReferralGive === 'referred') {
                        value[key] = 'Referred';
                    } else {
                        value[key] = setResponseStatus(value[key]);
                    }
                } else {
                    value[key] = setRequestStatus(value[key]);
                }
            }
            // Normalize empty or undefined values (except date fields)
            if(filename != 'donor-engagement' && filename != 'referrals') {
                if (isEmpty(value[key]) && !dateFields.includes(key)) {
                    value[key] = 'N/A';
                }
            }
            if (dateFields.includes(key)) {
                return value[key] && value[key].length ? moment(value[key]).tz('America/New_York').format(dateFormat) : 'N/A';
            } else {
                if (typeof value[key] == 'number') {
                    return value[key];
                } else {
                    let REGEX_JAPANESE = /[\u3000-\u303f]|[\u3040-\u309f]|[\u30a0-\u30ff]|[\uff00-\uff9f]|[\u4e00-\u9faf]|[\u3400-\u4dbf]/;
                    let REGEX_CHINESE = /[\u4e00-\u9fff]|[\u3400-\u4dbf]|[\u{20000}-\u{2a6df}]|[\u{2a700}-\u{2b73f}]|[\u{2b740}-\u{2b81f}]|[\u{2b820}-\u{2ceaf}]|[\uf900-\ufaff]|[\u3300-\u33ff]|[\ufe30-\ufe4f]|[\uf900-\ufaff]|[\u{2f800}-\u{2fa1f}]/u;
                    if (REGEX_JAPANESE.test(value[key]) || REGEX_CHINESE.test(value[key])) {
                        value[key] = 'N/A';
                    }
                    let valuePera = value[key] ? value[key].toString() : "";
                    return valuePera.replace(/•/g, "-").replace(/•\t/g, "  ").replace("™", "");
                }
            }
        });
        return data;
    });

    if(filename == 'resources') {
        // const desiredOrder = ['name', 'description', 'type', 'roles', 'clicks', 'community', 'circle'];
        keys = keys.map(key => key === 'countOfClicks' ? 'clicks' : key);
        // keys = desiredOrder.filter(key => keys.includes(key)).concat(keys.filter(key => !desiredOrder.includes(key)));
        // values = values.map(row => {
        //     let reorderedRow = [];
        //     keys.forEach(key => {
        //         reorderedRow.push(row[key]);
        //     });
        //     return reorderedRow;
        // });
    }
    values.unshift(keys);
    let timestamp = moment(new Date()).format('DD_MM_YYYY_ss');
    let csvContent = await convertArrayToCSV(values, {keys, separator: ','});
    if(csvContent.length) {
        const url = window.URL.createObjectURL(new Blob([csvContent]))
		const link = document.createElement('a')
		link.href = url
		link.setAttribute('download', `${filename}-${timestamp}.csv`) //or any other extension
		document.body.appendChild(link)
		link.click()
        // downloadCSV({filename: `${filename}-${timestamp}.csv`, data: csvContent});
        return true;
    }
}

// Move an array element from array position
function array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
};

function downloadCSV(args) {
    var data, filename, link;
    var csv = args.data;
    if (csv == null) return;

    filename = args.filename || 'export.csv';

    if (!csv.match(/^data:text\/csv/i)) {
        csv = 'data:text/csv;charset=utf-8,' + csv;
    }
    data = encodeURI(csv);

    link = document.createElement('a');
    link.setAttribute('href', data);
    link.setAttribute('download', filename);
    link.click();
}

export function arrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}

/**
 * Date-range param for the API: a bare "YYYY-MM-DD" (the date's UTC calendar day).
 * The API's resolveDateRange() (dateRange.helper.js) snaps a bare day to whole days
 * in the report time zone. Sending an instant instead (toISOString) lets the
 * conversion slide "00:00Z" back into the previous day, so a "Last 30 Days" table
 * picked up an extra day versus the report CSV. Every page sends days this way.
 * @param {Date|string} date
 * @returns {String} "YYYY-MM-DD", or '' when missing/invalid
 */
export function toDayParam(date) {
    if (!date) return '';
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) return date;
    const d = date instanceof Date ? date : new Date(date);
    return isNaN(d) ? '' : d.toISOString().slice(0, 10);
}

/**
 * Custom dates come from the picker on the viewer's LOCAL calendar; presets are
 * computed in UTC. Re-anchor a custom pick to UTC midnight of the same calendar
 * day so toDayParam() yields the day the viewer actually picked (east of UTC a
 * local midnight is still the previous day in UTC).
 * @param {Date|string} date
 * @returns {Date|null}
 */
export function pickedDayToUtc(date) {
    if (!date) return null;
    const d = new Date(date);
    return isNaN(d) ? null : new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
}

/**
 * Start of a "Last N Days" window: UTC midnight of the day N-1 days before today,
 * so the window is exactly N calendar days INCLUDING today (Last 7 on Oct 14 =
 * Oct 8..14). Subtracting the full N used to add an extra day — "Last 7 Days"
 * exported 8 days of rows. Every preset and every "last 30 days" default uses this.
 * @param {number} days
 * @param {Date} [now]
 * @returns {Date}
 */
export function lastNDaysStart(days, now = new Date()) {
    const start = new Date(now);
    start.setUTCDate(start.getUTCDate() - (days - 1));
    start.setUTCHours(0, 0, 0, 0);
    return start;
}

/**
 * Inverse of toDayParam for a custom range forwarded in the URL: a bare
 * "YYYY-MM-DD" becomes LOCAL midnight of that day (what the picker shows and what
 * pickedDayToUtc expects). Anything else is parsed as a normal date.
 * @param {string} value
 * @returns {Date}
 */
export function dayParamToLocal(value) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    return m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(value);
}

/**
 * Checks if a value is empty: null, undefined, empty string, or empty array
 * @param {*} val
 * @returns {Boolean}
 */
function isEmpty(val) {
    return (
        val === undefined ||
        val === null ||
        (typeof val === 'string' && val.trim().length === 0) ||
        (Array.isArray(val) && val.length === 0)
    );
}
